import Favorites from './Favorites';
import RecentEvents from './RecentEvents';

const recentEventsMenu = {
  id: 'Recent',
  text: 'Recent',
  Icon: 'recentIcon',
  TopGroup: true,
  contentInfos: {
    menu: {
      contentType: 1,
      contentData: {
        Template: 'MenuItems',
        Title: 'Recent',
        SubTitle: 'Recent events',
        Component: RecentEvents,
      },
    },
  },
};

const favoritesMenu = {
  id: 'Favorites',
  text: 'Favorites',
  Icon: 'favoritesIcon',
  TopGroup: true,
  contentInfos: {
    menu: {
      contentType: 1,
      contentData: {
        Template: 'MenuItems',
        Title: 'Favorites',
        SubTitle: 'Favorite items',
        Component: Favorites,
      },
    },
  },
};

export default [
  {
    index: 3,
    config: recentEventsMenu,
  },
  {
    index: 4,
    config: favoritesMenu,
  },
];
